// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.rentguarantee.RentalManagerUserPropertyRentGuaranteeWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  CreateStripeSetupIntentByPolicyIdRequestDto,
  CreateStripeSetupIntentResponseDto,
  GetPremiumPaymentDashboardDataResponseDto,
  GetRentalProtectionPolicyCostByPolicyIdResponseDto,
  ListingAlias,
  LowFrictionStatusDto,
  RentGuaranteeDropPolicyWebApiRequestDto,
  RentTermDto,
  RetrieveStoredPaymentMethodsResponseDto,
  SavePolicyPaymentMethodRequestDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface CheckForActivePaymentTermParams {
  policyId: string;
}
interface GetLowFrictionStatusParams {
  listingAlias: ListingAlias;
}
interface GetPremiumPaymentDashboardDataParams {
  policyId: string;
}
interface GetRentalProtectionPolicyCostByPolicyIdParams {
  policyId: string;
}

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Options = UseQueryOptions<
  RentTermDto,
  unknown,
  RentTermDto,
  readonly [string, CheckForActivePaymentTermParams]
>;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_GetKey = (
  getParams: CheckForActivePaymentTermParams,
) => [RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Path, getParams] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_queryOptions = (
  getParams: CheckForActivePaymentTermParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * check for active payment term for a policy
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm = (
  getParams: CheckForActivePaymentTermParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_GetKey;

export interface RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Args {
  postData: CreateStripeSetupIntentByPolicyIdRequestDto;
}

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Options = UseMutationOptions<
  CreateStripeSetupIntentResponseDto,
  unknown,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Args
>;

/**
 * get stripe setup intent for policy
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Args) =>
      RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Args {
  postData: RentGuaranteeDropPolicyWebApiRequestDto;
}

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Args
>;

/**
 * drop rental protection policy and remove experiment stored data
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Args) =>
      RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy(args.postData, httpClient),
  });
};

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Options = UseQueryOptions<
  LowFrictionStatusDto,
  unknown,
  LowFrictionStatusDto,
  readonly [string, GetLowFrictionStatusParams]
>;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_GetKey = (
  getParams: GetLowFrictionStatusParams,
) => [RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Path, getParams] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_queryOptions = (
  getParams: GetLowFrictionStatusParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get low friction status for listing
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus = (
  getParams: GetLowFrictionStatusParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Options =
  UseQueryOptions<
    GetPremiumPaymentDashboardDataResponseDto,
    unknown,
    GetPremiumPaymentDashboardDataResponseDto,
    readonly [string, GetPremiumPaymentDashboardDataParams]
  >;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_GetKey = (
  getParams: GetPremiumPaymentDashboardDataParams,
) => [RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Path, getParams] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_queryOptions = (
  getParams: GetPremiumPaymentDashboardDataParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get premium payment dashboard data
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData = (
  getParams: GetPremiumPaymentDashboardDataParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Options =
  UseQueryOptions<
    GetRentalProtectionPolicyCostByPolicyIdResponseDto,
    unknown,
    GetRentalProtectionPolicyCostByPolicyIdResponseDto,
    readonly [string, GetRentalProtectionPolicyCostByPolicyIdParams]
  >;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_GetKey = (
  getParams: GetRentalProtectionPolicyCostByPolicyIdParams,
) =>
  [
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Path,
    getParams,
  ] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_queryOptions =
  (getParams: GetRentalProtectionPolicyCostByPolicyIdParams, { httpClient }: { httpClient?: Client } = {}) =>
    ({
      ...tsClientOptions.queryOptions,
      queryKey:
        RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_GetKey(getParams),
      queryFn: () =>
        RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId(
          getParams,
          httpClient,
        ),
    }) as const satisfies QueryOptions;

/**
 * get rental protection policy cost by policyId
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId = (
  getParams: GetRentalProtectionPolicyCostByPolicyIdParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_queryOptions(
      getParams,
      { httpClient },
    ),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Options = UseQueryOptions<
  RetrieveStoredPaymentMethodsResponseDto,
  unknown,
  RetrieveStoredPaymentMethodsResponseDto,
  readonly [string]
>;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_GetKey = () =>
  [RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Path] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_GetKey(),
    queryFn: () => RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods(httpClient),
  }) as const satisfies QueryOptions;

/**
 * retrieve stored payment methods for user
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods = ({
  httpClient,
  ...options
}: Omit<
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Options,
  'queryFn' | 'queryKey'
> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_GetKey;

export interface RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Args {
  postData: SavePolicyPaymentMethodRequestDto;
}

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Args
>;

/**
 * save Stripe payment method for policy
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Args) =>
      RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod(args.postData, httpClient),
  });
};
